import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[libLmCarouselItem]',
  standalone: true,
})
export class LmCarouselItemDirective {
  constructor(public template: TemplateRef<LmCarouselItemDirective>) {}
}
